import {
  findDeepGetTask,
  isGrouped,
  updateAsyncTaskGanttV2
} from '../../GanttVisualization.helper';

export const shouldSkipRendering = (task, gantt) =>
  task.is_milestone || !task.isTask || !gantt || isGrouped();

export const onSaveDescription = (task, columnName, newValue) => {
  const activities = window.activities;
  const gantt = window.ganttVisualization;
  const taskFromLookahead = findDeepGetTask(activities, 'id', task.id);
  const description = newValue;
  updateAsyncTaskGanttV2(taskFromLookahead, columnName, description, gantt);
};
